import { TrackingInit } from '@vrplatform/data';
import {
  RootThemeProvider,
  V2Provider,
  type AppTheme,
} from '@vrplatform/theme';
import type { ReactNode } from 'react';
import { ErrorBoundary } from '../components';
import { PwaProvider } from './PwaProvider';
import { ReloadPrompt } from './ReloadPrompt';

export const AppWrapper = ({
  children,
  themePrimaryColor,
}: {
  children: ReactNode;
  themePrimaryColor: AppTheme;
}) => {
  return (
    <ErrorBoundary>
      <TrackingInit>
        <V2Provider>
          <RootThemeProvider themePrimaryColor={themePrimaryColor}>
            <PwaProvider>
              {children}
              <ReloadPrompt />
            </PwaProvider>
          </RootThemeProvider>
        </V2Provider>
      </TrackingInit>
    </ErrorBoundary>
  );
};
